import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  height: 56px;
  flex: 1;
`;

export const IconPadding = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

export const EditIcon = styled.img`
  width: 26px;
  height: 26px;
`;

export const InfoIcon = styled.img`
  width: 14px;
  height: 14px;
  color: 008cff;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 48px;
`;

export const HeaderTitle = styled.p`
  color: #000000;
  font-size: 18px;
  padding: 0;
  align-self: center;
  align-items: center;
  font-family: 'Rubik';
  font-weight: 700;
  text-align: center;
`;